/* eslint-disable @typescript-eslint/no-explicit-any */
import { SimpleGrid } from "@mantine/core";
import RecentPatientComponent from "../components/Home/RecentPatientComponent";
import RecentTemplateComponent from "../components/Home/RecentTemplateComponent";
import ReferralComponent from "../components/Home/ReferralComponent";
import UserComponent from "../components/Home/UserComponent";

function Home() {
  // const navigate = useNavigate();
  return (
    <>
      <SimpleGrid p={15}>
        <UserComponent showHeader={false} />
      </SimpleGrid>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} p={15}>
        <RecentTemplateComponent />
        <RecentPatientComponent />
        <ReferralComponent />
      </SimpleGrid>
    </>
  );
}

export default Home;
